import { render, staticRenderFns } from "./SignupInviteForm.vue?vue&type=template&id=60988f58&scoped=true&"
import script from "./SignupInviteForm.vue?vue&type=script&lang=js&"
export * from "./SignupInviteForm.vue?vue&type=script&lang=js&"
import style0 from "./SignupInviteForm.vue?vue&type=style&index=0&id=60988f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60988f58",
  null
  
)

export default component.exports